module.exports = __webpack_public_path__ + "media/fonts/dinot/dinotitalic-e943b9be988c3078bd9754f2ed3381ff.woff2";